// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ballsColor {
  width: 15px;
  height: 15px;
  font-size: 1px;
  border-radius: 35px;
}

.statusCurrent {
  display: flex;
  padding-left: 4px;
  font-size: 16px;
  color: #000;
}

.statusCurrent span {
  margin-left: 10px;
}

.StatusColors {
  display: flex;
  align-items: center;
  padding-right: 20px;
  margin-top: 3px;
}
`, "",{"version":3,"sources":["webpack://./src/componentes/fluxo-engenheiro/ballsColor/ballsColor.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;AACjB","sourcesContent":[".ballsColor {\n  width: 15px;\n  height: 15px;\n  font-size: 1px;\n  border-radius: 35px;\n}\n\n.statusCurrent {\n  display: flex;\n  padding-left: 4px;\n  font-size: 16px;\n  color: #000;\n}\n\n.statusCurrent span {\n  margin-left: 10px;\n}\n\n.StatusColors {\n  display: flex;\n  align-items: center;\n  padding-right: 20px;\n  margin-top: 3px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
